module.exports = __webpack_public_path__ + "img/zl2.e5088543.jpg";